import { Id } from 'ev-types';

import { EdataAttributes } from '../visits';

export enum FormTrigger {
  SharedForms = 'shared_forms',
  CreateAVisit = 'create_a_visit',
  VisitNotes = 'visit_notes',
}

export type GetVisitSubmissionsParams = {
  visitId: Id;
  formTrigger?: FormTrigger;
  practiceId?: Id;
};

export type GetHistoriesParams = {
  patientId: Id;
  formTrigger?: FormTrigger;
  currentVisitId?: Id;
};

export type GetSubmissionParams = {
  submissionId: Id;
};

export type PatchSubmissionParams = {
  submissionId: Id;
  customFormId: Id;
  customFormVersionId: Id;
  eDataValues: EdataAttributes[];
};

export type CreateSubmissionParams = {
  customFormId: Id;
  customFormVersionId: Id;
  visitId: Id;
  eventTrigger: FormTrigger;
};
